<script setup>
import SCardWithToolbar from '@/components/global/s-card-with-toolbar.vue'
import StatutFicheAim from '@/components/fiche-aim/status-fiche-aim.vue'
import LigneAimExpensionPanel from '@/components/fiche-aim/ligne/ligne-aim-expension-panel.vue'
import ficheAIM from '../../../store/modules/aim/ficheAIM'
import DialogDemandeValidationFicheAim from '@/components/fiche-aim/fiche-aim/dialog-demande-validation-fiche-aim.vue'
import TraitementDemandeFicheAim from '@/components/fiche-aim/traitement-demande-fiche-aim.vue'
import SInfoMontant from '@/components/global/s-info-montant.vue'
</script>

<template>
  <s-card-with-toolbar is-extented :loading="loading">
    <template v-if="!!ficheAIM" #titre>
      Fiche d'Aide Individuelle Mensuelle - {{ ficheAim.mois }}/{{ ficheAim.annee }}
    </template>
    <template #top>
      <v-container>
        <v-row no-gutters align="center">
          <v-col cols="4" align-self="center">
            <span>Poste</span>
          </v-col>
          <v-col cols="8" class="text--secondary">
            <v-row no-gutters style="width: 100%" align="center">
              <v-col class="text-right pr-10" cols="4">
                <span>Montant acquis</span>
              </v-col>
              <v-col class="text-right pr-12" cols="4">
                <span>Montant versé</span>
              </v-col>
              <v-col class="text-right pr-3" cols="4">
                <v-row justify="end" align="center">
                  <span>Solde fin de mois</span>
                  <v-checkbox
                    v-if="modeVersement"
                    class="mt-0 pt-0 ml-6"
                    hide-details
                    :value="sontToutPostesVersementSelectionne"
                    @click.stop="handleCheckAll"
                  />
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template #actions><statut-fiche-aim :statut-fiche="ficheAim.statut" /></template>
    <template #default>
      <perfect-scrollbar class="h-100" v-if="!loading">
        <v-expansion-panels @change="reinitializerAjustementSelectionne" v-model="lignesActives" multiple>
          <ligne-aim-expension-panel
            v-for="ligne in ficheAim.lignes"
            :key="ligne.ligneFicheId"
            :ligne-fiche-aim="ligne"
            :soldes="soldesUsager"
            :versements-du-mois="versements"
            :selectable="modeVersement"
          />
        </v-expansion-panels>
      </perfect-scrollbar>
    </template>
    <template #bottom>
      <v-container>
        <v-row class="pa-2" align="center" justify="space-between">
          <dialog-demande-validation-fiche-aim
            v-if="ficheAim.statut === 'EN_PREPARATION'"
            :fiche-aim-id="ficheAim.ficheAIMId"
            @changed="reload"
          />
          <traitement-demande-fiche-aim
            v-if="ficheAim.statut === 'EN_ATTENTE_DE_VALIDATION'"
            :fiche-aim-id="ficheAim.ficheAIMId"
            @changed="reload"
          />
          <v-chip class="text-body-1 pa-4" color="primary" label outlined>
            <span>Total : </span>
            <s-info-montant :montant="total"></s-info-montant>
          </v-chip>
        </v-row>
      </v-container>
    </template>
  </s-card-with-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'rendu-fiche-aim',
  props: {
    ficheAim: {
      type: Object,
      required: true,
    },
    modeVersement: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lignesActives: [],
      soldesUsager: [],
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      estAjustementConcerneParAjustementSelectionne:
        'renduAIM_IHM_helper/estAjustementConcerneParAjustementSelectionne',
      estSelectionne: 'renduAIM_IHM_helper/estSelectionne',
      versements: 'versement/getVersements',
      sontToutPostesVersementSelectionne: 'preparationVersement_IHM_helper/sontToutPostesVersementSelectionne',
    }),
    ligneFicheAimVersable() {
      return this.ficheAim.lignes.filter((l) => l.montantFinal > 0)
    },
    indexLignesConcernesParSelection() {
      let indexLignes = []
      this.ficheAim.lignes.forEach((ligne, i) => {
        if (ligne.operations.some((op) => this.estAjustementConcerneParAjustementSelectionne(op.ajustementId))) {
          indexLignes.push(i)
        }
      })
      return indexLignes
    },
    total() {
      return this.ficheAim.lignes
        .filter((l) => l.montantFinal > 0)
        .map((l) => l.montantFinal)
        .reduceRight((acc, cur) => acc + cur, 0)
    },
  },
  methods: {
    ...mapActions({
      reinitializerAjustementSelectionne: 'renduAIM_IHM_helper/reinitializerAjustementSelectionne',
      ajouterPosteAVerser: 'preparationVersement_IHM_helper/ajouterPosteAVerser',
      ajouterToutLesPostes: 'preparationVersement_IHM_helper/ajouterToutLesPostes',
      retirerToutLesPostesAVerser: 'preparationVersement_IHM_helper/retirerToutLesPostesAVerser',
      obtenirSoldesUsagerDansEtablissementAvantFiche: 'usager/obtenirSoldesUsagerDansEtablissementAvantFiche',
      obtenirVersementsDuMois: 'versement/obtenirVersementsUsagerPourMoisEtEtablissement',
      fetchFicheAimByFicheId: 'ficheAIM/fetchFicheAimByFicheId',
    }),
    reload() {
      this.loading = true
      this.fetchFicheAimByFicheId(this.ficheAim.ficheAIMId).then(() => (this.loading = false))
    },
    handleCheckAll() {
      if (this.sontToutPostesVersementSelectionne) {
        this.retirerToutLesPostesAVerser()
      } else {
        this.ajouterToutLesPostes(this.ligneFicheAimVersable)
      }
    },
    loadSoldesDebutDeMois() {
      this.loading = true
      this.obtenirSoldesUsagerDansEtablissementAvantFiche({
        usagerId: this.ficheAim.usager.usagerId,
        etablissementId: this.ficheAim.etablissement.etablissementId,
        ficheAimId: this.ficheAim.ficheAIMId,
      }).then((value) => {
        this.soldesUsager = value
        this.loading = false
      })
    },
    loadVersementsDuMois() {
      this.loading = true
      this.obtenirVersementsDuMois({
        usagerId: this.ficheAim.usager.usagerId,
        etablissementId: this.ficheAim.etablissement.etablissementId,
        mois: this.ficheAim.mois,
        annee: this.ficheAim.annee,
      }).then(() => {
        this.loading = false
      })
    },
    load() {
      this.loadSoldesDebutDeMois()
      this.loadVersementsDuMois()
    },
  },
  watch: {
    indexLignesConcernesParSelection: function (indexLignes) {
      if (this.estSelectionne) this.lignesActives = indexLignes
    },
    ficheAim: function (fiche, oldFiche) {
      if (fiche.ficheAIMId !== oldFiche.ficheAIMId) this.load()
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style>
.h-100 {
  height: 100% !important;
}
</style>
